module.exports = __webpack_public_path__ + "static/media/34_B.78b8da7a.png";